<template>
  <b-container>
  <b-navbar toggleable="lg" type="dark" variant="dark">
    <b-navbar-brand v-on:click="reload" mx-auto class="logo">
      <img v-bind:src="$i18n.locale === 'fr' ? 'Images/cogir-rev-fr-110x110.png' : 'Images/cogir-rev-en-110x110.png'"
      class="d-inline-block align-top" alt="logo cogir">
    </b-navbar-brand>
    <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

    <b-collapse id="nav-collapse" is-nav>
    <b-navbar-nav class="ml-auto">
        <b-nav-item v-if="!user" v-on:click="goTo('Register')">{{ $t("label.register") }}</b-nav-item>
        <b-nav-item v-if="!user" v-on:click="goTo('Login')">{{ $t("label.login") }}</b-nav-item>
        <b-nav-item v-if="user && appProcessStatus" v-on:click="goTo('ApplicationsProcess')">{{ $t("label.dashboard") }}</b-nav-item>
        <b-nav-item v-if="user && appProcessStatus" v-on:click="goTo('EndorserProcess')">{{ $t("label.endorser") }}</b-nav-item>
        <b-nav-item v-if="user && appProcessStatus" v-on:click="goTo('MissingDoc')">{{ $t("label.missingDoc") }}</b-nav-item>
        <b-nav-item-dropdown right>   
          <template v-slot:button-content>
            <em>{{$t('label.language')}}</em>
          </template>      
          <b-dropdown-item v-on:click="getLang('en')">{{ $t("label.english") }}</b-dropdown-item>
          <b-dropdown-item v-on:click="getLang('fr')">{{ $t("label.french") }}</b-dropdown-item>
        </b-nav-item-dropdown>
        <b-nav-item-dropdown v-if="user" right>   
          <template v-slot:button-content>
            <em>{{$t('label.user')}}</em>
          </template>      
          <b-dropdown-item>{{user.Email}}</b-dropdown-item>
          <b-dropdown-item v-on:click="logOut()">{{ $t("label.logout") }}</b-dropdown-item>
        </b-nav-item-dropdown>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar> 
</b-container>
</template>

<script>
export default {
  data: () => ({}),
   mounted () {
    },
  computed: {
    user: function () {
      return this.$store.getters.getUser;
    },
    appProcessStatus: function () {
      let status = false;
      let process = this.$store.getters.getProcess;
      if (process.length === 4) {
        if (process[3].Step === 3) {
          status = true;
        }
      }
      return status;
    }
  },
  methods:{
    getLang: function (val) {
      this.$i18n.locale = val;
      localStorage.setItem("application.cogir.net.language", val);
    },
    goTo : function (val) {
      this.$emit('changePage', val);
    },
    logOut: function () {
      let website = this.$store.getters.getWebsite;
      localStorage.removeItem(website);
      window.location.reload(true);
    },
    reload: function () {
      window.location.reload(true);
    }
  },
  components: {
  }
}
</script>
